import { renderWishlist } from "components/Wishlist"

function init() {
  renderWishlist()
}

if (document.readyState !== "loading") {
  init()
} else {
  document.addEventListener("DOMContentLoaded", init)
}
